import slugify from 'utils/slugify'

export default (venueId, venueName) => {
  return venueId && venueName
    ? `/restaurant/${venueId}/${slugify(venueName)}`
    : `/account/profile`
}
